import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MiniProfileComponent } from './mini-profile.component';

@NgModule({
  declarations: [MiniProfileComponent],
  imports: [
    CommonModule,
    RouterModule
  ],
  exports: [MiniProfileComponent]
})
export class MiniProfileModule { }
